<template>
<div class="preview-card"
  :id="item.itemId + '-' + itemIndex + '-preview'">
  <div class="horizontal">
    <template v-if="item.heading">
      <div class="left">{{ item.heading }}</div>
      <div class="right">{{ item.data.url }}</div>
    </template>
    <template else>
      <p>{{ item.data.url }}</p>
    </template>
  </div>
  <expert-comment v-bind:item="item"
    v-if="isConsultationPlan"
    v-bind:groupIndex="groupIndex"
    v-bind:itemIndex="itemIndex"
    v-bind:isEditableComment="isEditableComment"></expert-comment>
  </div>
  </template>

  <script>
  import expertComment from '@/components/parts/ExpertComment'
  export default {
  components: {
    'expert-comment': expertComment
  },
  data() {
    return {}
  },
  props: ['item', 'groupIndex', 'itemIndex', 'isConsultationPlan', 'isEditableComment'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
